import { render, staticRenderFns } from "./nav-title.vue?vue&type=template&id=a0abdd98&scoped=true&"
import script from "./nav-title.vue?vue&type=script&lang=js&"
export * from "./nav-title.vue?vue&type=script&lang=js&"
import style0 from "./nav-title.vue?vue&type=style&index=0&id=a0abdd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0abdd98",
  null
  
)

export default component.exports